export default {
    namespaced: true,
    state: () => ({
        currentGame: null,
        puzzlesSolved: 0,
        rating: 1500
    }),
    mutations: {
        SET_GAME(state, game) {
            state.currentGame = game;
        },
        INCREMENT_PUZZLES(state) {
            state.puzzlesSolved++;
        },
        SET_RATING(state, rating) {
            state.rating = rating;
        }
    },
    actions: {},
    getters: {
        puzzlesSolved: (state) => state.puzzlesSolved,
        rating: (state) => state.rating
    }
};
